





export default {
  name: 'SidebarMenuItem',
};
